module.exports = __webpack_public_path__ + "img/img97.55ab025f.svg";